import {
  Box,
  Heading,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import makeup from "../../Assets/makeup-icon.png";
import skin from "../../Assets/skin-small.png";
import hair from "../../Assets/hair-small.png";
import personal from "../../Assets/personal-care-small.png";
import momandbaby from "../../Assets/mom-baby-care-small.png";
import fragrance from "../../Assets/fragrance.png";
import ayurveda from "../../Assets/ayurveda.png";

export default function HomeTabs() {
  return (
    <>
      <Tabs
        w={{ base: "100%", md: "85%" }}
        m="auto"
        mt="3%"
        mb="3%"
        colorScheme={"pink"}
      >
        <TabList className="HomeTablist">
          <Tab w={"25%"} _hover={{ backgroundColor: "#D3D3D3" }}>
            <Box>
              <Image
                m="auto"
                boxSize={{ base: "30px", md: "40px" }}
                color="white"
                src={makeup}
              />
              <Text fontSize={{ base: "10px", md: "14px", lg: "16px" }}>
                Make Up
              </Text>
            </Box>
          </Tab>
          <Tab w={"25%"} _hover={{ backgroundColor: "#D3D3D3" }}>
            <Box>
              <Image
                m="auto"
                boxSize={{ base: "30px", md: "40px" }}
                src={skin}
              />
              <Text fontSize={{ base: "10px", md: "14px", lg: "16px" }}>
                Skin
              </Text>
            </Box>
          </Tab>

          <Tab w={"25%"} _hover={{ backgroundColor: "#D3D3D3" }}>
            <Box>
              <Image
                m="auto"
                boxSize={{ base: "30px", md: "40px" }}
                src={hair}
                alt="hair"
              />
              <Text fontSize={{ base: "10px", md: "14px", lg: "16px" }}>
                Hair
              </Text>
            </Box>
          </Tab>
          <Tab w={"25%"} _hover={{ backgroundColor: "#D3D3D3" }}>
            <Box>
              <Image
                m="auto"
                boxSize={{ base: "30px", md: "40px" }}
                src={personal}
                alt="personal"
              />
              <Text fontSize={{ base: "10px", md: "14px", lg: "16px" }}>
                Personal Care
              </Text>
            </Box>
          </Tab>

          <Tab w={"25%"} _hover={{ backgroundColor: "#D3D3D3" }}>
            <Box>
              <Image
                m="auto"
                boxSize={{ base: "30px", md: "40px" }}
                src={momandbaby}
                alt="momandbaby"
              />
              <Text fontSize={{ base: "10px", md: "14px", lg: "16px" }}>
                Mom & Baby Care
              </Text>
            </Box>
          </Tab>
          <Tab w={"25%"} _hover={{ backgroundColor: "#D3D3D3" }}>
            <Box>
              <Image
                m="auto"
                boxSize={{ base: "30px", md: "40px" }}
                src={fragrance}
                alt="fragrance"
              />
              <Text fontSize={{ base: "10px", md: "14px", lg: "16px" }}>
                Fragrance
              </Text>
            </Box>
          </Tab>

          <Tab w={"25%"} _hover={{ backgroundColor: "#D3D3D3" }}>
            <Box>
              <Image
                m="auto"
                boxSize={{ base: "30px", md: "40px" }}
                src={ayurveda}
                alt="ayurveda"
              />
              <Text fontSize={{ base: "10px", md: "14px", lg: "16px" }}>
                Ayurveda
              </Text>
            </Box>
          </Tab>
        </TabList>

        {/* <TabPanels>
          <TabPanel>
            <Heading>MakeupTab</Heading>
          </TabPanel>
          <TabPanel>
            <Heading>SkinTab</Heading>
          </TabPanel>
          <TabPanel>
            <Heading>HairTab</Heading>
          </TabPanel>
          <TabPanel>
            <Heading>PersonalCareTab</Heading>
          </TabPanel>
          <TabPanel>
            <Heading>MummyAndBbyTab</Heading>
          </TabPanel>
          <TabPanel>
            <Heading>EyeTab</Heading>
          </TabPanel>
          <TabPanel>
            <Heading>FragranceTab</Heading>
          </TabPanel>
        </TabPanels> */}
      </Tabs>
    </>
  );
}
